import { type JSX, useMemo, useState } from "react";

export type ModalNavigationConfig = {
  [key: string]: (navigate: (route: string) => void) => JSX.Element;
};

type UseModalNavigationOptions = {
  initialRoute?: string;
};

export const useModalNavigation = (
  routes: ModalNavigationConfig,
  options?: UseModalNavigationOptions,
) => {
  const defaultRoute = useMemo(() => Object.keys(routes)[0], [routes]);
  const initialRoute =
    options?.initialRoute && options.initialRoute in routes
      ? options.initialRoute
      : defaultRoute;

  const [currentRoute, setCurrentRoute] = useState<string | null>(initialRoute);

  const navigate = (route: string) => setCurrentRoute(route);
  const goBack = () => setCurrentRoute(defaultRoute);

  return {
    currentComponent:
      currentRoute && currentRoute in routes
        ? routes[currentRoute](navigate)
        : null,
    navigate,
    goBack,
    isHome: !currentRoute || currentRoute === defaultRoute,
  };
};
